import {useQuery} from '@tanstack/react-query';
import {useDashboardDate} from '@/contexts/DashboardDateContext';
import {useDashboardDataSource} from '@/contexts/DashboardDataSourceContext';
import {reportingPeriod} from '@shared/analyticsReporting';

export function AnalyticsCoverageNotice() {
  const {startDate,endDate,comparisonStartDate}=useDashboardDate();
  const {getUrl,dataKey}=useDashboardDataSource();
  const extendedStart=comparisonStartDate<startDate?comparisonStartDate:startDate;
  // Share the KPI request/cache so coverage and totals describe the same rows.
  const {data}=useQuery({
    queryKey:['dashboard-daily-trend',dataKey,extendedStart,endDate],
    queryFn:async()=>{
      const response=await fetch(getUrl('daily-trend',new URLSearchParams({startDate:extendedStart,endDate})));
      if(!response.ok)throw new Error('Failed to fetch trend data');
      return response.json() as Promise<Array<Record<string,any>>>;
    },
  });
  if(!data)return null;
  const coverage=reportingPeriod(data,startDate,endDate);
  if(coverage.complete)return null;
  return <div role="status" data-testid="analytics-coverage-notice" className="analytics-source-notice mx-6 mt-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950">
    {coverage.reportedDays===0?'No data is available for the selected dates.':`Data is available for ${coverage.reportedDays} of the ${coverage.totalDays} days selected. Totals reflect those days; incomplete periods are not compared.`}
  </div>;
}
